// Shared compact "upgrade analysis" strip + details modal, used by the Site and
// Circuit upgrade-analysis dashlets. The strip is a single row; the full table /
// breakdown lives in a Bootstrap modal opened by the row (mouse) or the
// "More details" button (keyboard).

const MODAL_ID = "upgrade-analysis-modal";

// Calm, non-alarming badge used for the upgrade strip and the modal summary.
// Severity is carried by the wording ("Upgrade recommended" / "Watch for
// upgrade"), not by colour.
export const UPGRADE_NEUTRAL_ICON = "fa-circle-info";

function escapeHtml(value) {
    return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function ensureModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal && modal.isConnected) return modal;

    modal = document.createElement("div");
    modal.id = MODAL_ID;
    modal.className = "modal fade";
    modal.tabIndex = -1;
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("aria-labelledby", `${MODAL_ID}-title`);
    modal.innerHTML = `
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="${MODAL_ID}-title" data-role="title"></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" data-role="body"></div>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener("hidden.bs.modal", () => {
        const trigger = modal._upgradeTrigger;
        if (trigger && trigger.isConnected && typeof trigger.focus === "function") {
            trigger.focus();
        }
    });
    return modal;
}

export function openUpgradeModal(titleText, bodyHtml, trigger) {
    const modal = ensureModal();
    modal.querySelector('[data-role="title"]').textContent = titleText;
    modal.querySelector('[data-role="body"]').innerHTML = bodyHtml;
    modal._upgradeTrigger = trigger || null;
    window.bootstrap.Modal.getOrCreateInstance(modal, { keyboard: true }).show();
}

// `buildBody()` returns the modal HTML (lazily, on open).
export function renderUpgradeStrip(target, options) {
    if (!target) return;
    const { icon, badgeLabel, headline, detail = "", modalTitle, buildBody, muted = false } = options;
    const stripClass = muted
        ? "lqos-strip lqos-upgrade-strip is-muted"
        : "lqos-strip lqos-upgrade-strip";

    target.innerHTML = `
        <div class="${stripClass}" data-role="strip">
            <span class="lqos-strip-badge"><i class="fa ${icon} me-1" aria-hidden="true"></i>${escapeHtml(badgeLabel)}</span>
            <span class="lqos-strip-status" title="${escapeHtml(headline)}">${escapeHtml(headline)}</span>
            ${detail ? `<span class="lqos-strip-detail">${escapeHtml(detail)}</span>` : ""}
            <button type="button" class="btn btn-sm lqos-strip-action" data-role="more">More details</button>
        </div>
    `;

    const strip = target.querySelector('[data-role="strip"]');
    const open = (trigger) => openUpgradeModal(modalTitle, buildBody(), trigger);

    // Row click is a mouse convenience; the real button handles keyboard.
    strip.addEventListener("click", (event) => {
        if (event.target.closest('[data-role="more"]')) return;
        open(strip);
    });
    target.querySelector('[data-role="more"]').addEventListener("click", (event) => {
        event.stopPropagation();
        open(event.currentTarget);
    });
}
